import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';

type DeliveryTimeWarningProps = {
    hour?: number | null;
    dataTest?: string;
};

const EARLIEST_RECOMMENDED_DELIVERY_HOUR = 10;

const DeliveryTimeWarning: FC<DeliveryTimeWarningProps> = ({ hour, dataTest }) => {
    const { t: translate } = useTranslation(['orders']);

    // No time selected (undefined/null) means nothing to warn about — only warn on a real early hour.
    if (hour === undefined || hour === null || hour >= EARLIEST_RECOMMENDED_DELIVERY_HOUR) {
        return null;
    }

    return (
        <Alert severity="warning" variant="outlined" sx={{ border: 0 }} data-test={dataTest}>
            {translate('orders:DELIVERY_TIME_BEFORE_10_WARNING')}
        </Alert>
    );
};

export default DeliveryTimeWarning;
